import { jsx } from "react/jsx-runtime";
const Alert = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: 16,
      height: 16,
      viewBox: "0 0 24 22",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "prefix__feather prefix__feather-alert-triangle",
      ...props,
      children: /* @__PURE__ */ jsx("path", { d: "M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0zM12 9v4M12 17h.01" })
    }
  );
};
export {
  Alert as default
};
